import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import IconImage from "../../image/neqst1.ico";
export default function LoginHeader(props) {
  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{ bgcolor: "green" }}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} textAlign="left">
              {`${process.env.REACT_APP_SCHOOL_NAME}`}
            </Typography>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <Avatar alt="Remy Sharp" variant="rounded" src={IconImage} />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </React.Fragment>
  );
}
